<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">竞价大厅</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='type' :list='navlist' @datashow=tableshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div class="ml-border">

          <div v-for="(item, index) in this.tenders">
            <div v-show="convertDateFromString(item.JEndTime) < new Date()">
            <div>
              <div style="display: flex;padding: 10px;justify-content: space-between;">
                <p style=" font-weight: bold;">
                  {{ item.Title }} 合同包 {{ item.Childlist[0].PackNum }}
                </p>
                <!-- <div style='color:#ff0000;padding-right: 50px;'>
                  <span v-if="convertDateFromString(item.JEndTime) < new Date()">已过期</span>
                  <span style="color: black;" v-else>竞价中</span>
                </div> -->
                <div style='color:#ff0000;padding-right: 50px;'>
                  <span>报价方式： {{ item.QuoteType == 1 ? '单次报价' : '多次报价' }}</span>
                </div>
              </div>
            </div>
            <el-table :data="item.Childlist" border style="font-size: 16px;" :row-style="{}"
              :cell-style="{ 'font-size': '14px' }" :header-row-style="{}" :fit="true">
              <el-table-column prop="Option" label="细项">
              </el-table-column>
              <el-table-column prop="Name" label="采购项目名称">
              </el-table-column>
              <el-table-column prop="Brand" label="品牌">
              </el-table-column>
              <el-table-column prop="StartPrice" label="竞价起标价">
              </el-table-column>
              <el-table-column label="竞价价格" width="350px">
                <template slot-scope="scope">
                  <router-link :to="'/Biddinglist?id='+scope.row.Id" style="line-height: 40px;position: relative;font-size: 14px;">历史竞价</router-link>
                  
                </template>
              </el-table-column>
            </el-table>
          </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "BiddingHistory",
  components: { leftmenu, leftlogin },
  data: function () {
    return {
      type: 4,
      Id: 0,
      navlist: [{ Word_Text: '个人资料', Word_Value: 1, Id: 1 },
      { Word_Text: '竞价报名', Word_Value: 2, Id: 2 },
      { Word_Text: '竞价大厅', Word_Value: 3, Id: 3 },
      { Word_Text: '竞价历史', Word_Value: 4, Id: 4 }
      ],
      tenders: [],
      form: {},
      fileList: []
    };
  },
  updated() {
  },
  created() {
    var that = this;
    that.getData();
  },
  watch: {
    $route: async function (to, from) {

    }
  },
  mounted() {

  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/Bidding/Get", null, r => {                
        that.tenders = r.response;
        console.log(r.response)
        var date = new Date();
        that.tenders = r.response.filter(function(x){                     
          return this.convertDateFromString(x.JEndTime) < date
        })
        
      });
    },
    tableshow(item) {
      var that = this;
      if (item.Id == 1)
        that.$router.replace("/UserCenter");
      if (item.Id == 2)
        that.$router.replace("/Enroll");
      if (item.Id == 3)
        that.$router.replace("/Bidding");
      return false;
    },
    convertDateFromString(dateString) {
      if (dateString) {
        var date = new Date(dateString.replace(/-/g, "/"));
        return date;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleAvatarSuccess(item, res, file) {
      var that = this;
      console.log(res.response)
      that.$api.post("/Enroll/Post", { TenderId: that.Id, PackNum: item.PackNum, UploadFiles: res.response }, data => {
        if (data.success) {
          this.$notify({
            type: "success",
            message: "上传成功!",
            duration: 3000
          });
          location.reload();
        } else {
          this.$message({
            type: "error",
            message: data.msg,
            showClose: true
          });
        }
      });
    },
    submit(item, TenderId) {
      var that = this;
      that.$api.post("/Bidding/Post", { TenderId: TenderId, ChildPackId: item.Id, PackNum: item.PackNum, price: item.jiage, Brand: item.pinpai, Remark: item.beizhu }, data => {
        if (data.success) {
          this.$notify({
            type: "success",
            message: "竞价成功!",
            duration: 3000
          });
          location.reload();
        } else {
          this.$message({
            type: "error",
            message: data.msg,
            showClose: true
          });
        }
      });
    }
  },
  computed: {

  }
};
</script>

<style>
.ml-border {
  margin-left: 20px;
  width: 100%;
  border: 1px solid #CCCCCC;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.pagination {
  text-align: center;
}
</style>